<template>
  <div id="app" class="app">
    <router-link to="/"></router-link>
    <router-view />

  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    created() {

    }

  }
</script>
<style lang="scss">
  body {
    -webkit-touch-callout: none; /*系统默认菜单被禁用*/
    -webkit-user-select: none; /*webkit浏览器*/
    -khtml-user-select: none; /*早起浏览器*/
    -moz-user-select: none; /*火狐浏览器*/
    -ms-user-select: none; /*IE浏览器*/
    user-select: none; /*用户是否能够选中文本*/
    font-size: 13px;
  }

  .maps {
    position: fixed !important;
  }

  .BMap_noprint {
    margin-left: -30px !important;

  }

  .amap-logo,
  .amap-copyright {
    display: none !important;
  }

  // canvas {
  //   width: auto !important;
  //   max-width: none !important;
  // }

  .anchorBL {
    display: none !important;
  }

  .BMap_Marker>div {
    overflow: inherit !important;
    //margin-left:-30px!important;
  }
  .van-overlay{
    width: 100%!important;
    height: 100%!important;
    position: fixed!important;
    left:0!important;
    top:0!important;
    overflow: scroll!important;
  }
  .amap-geolocation {
    display: none !important;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .app {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
  }

  .txt {
    height: 14px;
    line-height: 16px;
    font-size: 10px;
    text-align: center;
    max-width: 144px !important;
    background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 20%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0) 100%);
    padding: 0 5px;
    color: #753300;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .txt-tag {
    height: 10px;
    line-height: 10px;
    font-size: 10px;
    text-align: center;
    max-width: 144px !important;
   // text-shadow: 0 1px  rgba(255, 255, 255, 0.6), 1px 0  rgba(255, 255, 255, 0.6), -1px 0  rgba(255, 255, 255, 0.6), 0 -1px rgba(255, 255, 255, 0.6);
    padding: 2.5px;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background: rgba(149,149,155,0.8);
    border-radius: 2px;
  }

  .amap-marker-label {
    border: 0 !important;
    background: rgba(0, 0, 0, 0) !important;
  }

  .marker {
    width: 60px;
    min-height: 60px;
    position: absolute;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-flow: column;
    margin-left:-26px;
    margin-top: -30px;

    .icon {
      width: 70px !important;
      height: 70px !important;

    }

    .info {

      font-size: 10px;
      text-align: center;
      max-width: 144px !important;
      background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 20%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0.8) 80%, rgba(255, 255, 255, 0) 100%);
      padding: 0px 8px;
      color: #753300;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-top: -14px;

    }
    .infobaidu{
      font-size: 12px;
    }
  }

  .sheshi {
    width: 15px;
    height: 15px;

    .sheshi_icon {
      width: 15px;
      height: 15px;
    }
  }
  .line-class{
    border:0;

  }
  .line_yuan {
    width: 20px;
    height: 20px;
    margin-left:-4px;
    margin-top: -4px;
    border-radius: 20px;
    background: #f64a4a;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 12px;
  }

  .class-marker {
    width: 180px !important;
    padding: 0 10rpx;
    height: 20px !important;
    line-height: 20px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    margin-left: -90px !important;
    text-align: center !important;
    // margin-top: 10px!important;
  }

  .class-tag {
    height: 10px;
    line-height: 10px;
    font-size: 10px;
    text-align: center;
    max-width: 144px !important;
   // text-shadow: 0 1px  rgba(255, 255, 255, 0.6), 1px 0  rgba(255, 255, 255, 0.6), -1px 0  rgba(255, 255, 255, 0.6), 0 -1px rgba(255, 255, 255, 0.6);
    padding: 2.5px;
    color: #fff;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    background: rgba(149,149,155,0.8);
    border-radius: 2px;

   //  height: 14px;
   // line-height: 14px;
   //  display: inline-block;
   //  font-size: 12px;
   //  text-align: center;
    //text-shadow: 0 1px  rgba(255, 255, 255, 0.6), 1px 0  rgba(255, 255, 255, 0.6), -1px 0  rgba(255, 255, 255, 0.6), 0 -1px rgba(255, 255, 255, 0.6);
   // background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 25%, rgba(255, 255, 255, 0.5) 85%, rgba(255, 255, 255, 0.5) 85%, rgba(255, 255, 255, 0) 100%);
    // padding:0 10px;
    // color: #646d68;
    // -webkit-text-stroke: 2rpx #fff;
    // position: relative;
    // z-index: 0;
  }
  // .class-tag::after {
  // 	height: 100%;
  // 	content: attr(data-text);
  // 	position: absolute;
  // 	left: 0;
  // 	top: 0;
  // 	z-index: -1;
  // 	-webkit-text-stroke: 6rpx #000;
  // }
  .line-img{
    margin-top:-60px!important;
    z-index: 111111!important;
  }
</style>
